/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q4_PlaceholderInputs */

const en_consult_q4_placeholder = /** @type {(inputs: Consult_Q4_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the product, feature or automation…`)
};

const id_consult_q4_placeholder = /** @type {(inputs: Consult_Q4_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceritakan produk, fitur, atau automasinya…`)
};

/**
* | output |
* | --- |
* | "Describe the product, feature or automation…" |
*
* @param {Consult_Q4_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q4_placeholder = /** @type {((inputs?: Consult_Q4_PlaceholderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q4_PlaceholderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q4_placeholder(inputs)
	return en_consult_q4_placeholder(inputs)
});